import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { ForgotPasswordService } from './forgot-password.service';
import { LoadingMaskService } from '../../../shared/loading-mask/loading-mask.service';
import { Observable } from 'rxjs';

@Injectable()
export class ValidateRestoreCodeResolve implements Resolve<boolean> {
	constructor(private service: ForgotPasswordService,
	            private mask: LoadingMaskService) {
	}

	resolve(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
		let restoreCode = route.queryParams['RestoreCode'];
		if (!restoreCode) {
			return false;
		}
		this.mask.addLoading();
		return this.service.validateRestoreCode(restoreCode)
			.map((restoreCodeValid: boolean) => {
				this.mask.removeLoading();
				return restoreCodeValid;
			});
	}
}